import LocalStorage from './Storages/LocalStorage';

export default class Storages {
    public static Filters = LocalStorage.Instance;
    public static Settings = LocalStorage.Instance;
}
